module.exports = __webpack_public_path__ + "static/media/faq5.50e949f3.png";